import { TimedMetadataType } from '../core/player/player-engine-item';
export function checkIsId3DataCue(timedMetadata) {
    var knownId3DataCueFormats = [
        'org.id3'
    ];
    var isId3DataCue = timedMetadata.type === TimedMetadataType.DataCue && knownId3DataCueFormats.includes(timedMetadata.format);
    return isId3DataCue;
}

//# sourceMappingURL=timed-metadata.js.map